import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ResultsDialogueData {
    users: UserSummary[];
    totalResultsCount: number;
}

@Component({
    selector: "resultsdialogue",
    templateUrl: './resultsdialogue.component.html',
    standalone: false
})
export class ResultsDialogue {
    readonly users: UserSummary[];
    readonly count: number;

    constructor(
        public dialogRef: MatDialogRef<ResultsDialogue>,
        @Inject(MAT_DIALOG_DATA) data: ResultsDialogueData
    ) {
        this.users = data.users;
        this.count = data.totalResultsCount;
    }

    backButtonHandler() {
        this.dialogRef.close();
    }
}